"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Utilities_1 = require("office-ui-fabric-react/lib/Utilities");
var Label_1 = require("office-ui-fabric-react/lib/Label");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var FileField_classNames_1 = require("./FileField.classNames");
var FileField_styles_1 = require("./FileField.styles");
var FileNameList = /** @class */ (function (_super) {
    __extends(FileNameList, _super);
    function FileNameList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FileNameList.prototype.render = function () {
        if (this.props.files && this.props.files.length > 0) {
            var items = this.props.files.map(function (file, idx) {
                return (React.createElement("div", { key: idx, className: "file-name" }, file.name));
            });
            return (React.createElement("div", { className: "file-name-list" }, items));
        }
        return null;
    };
    return FileNameList;
}(React.Component));
var defaultFilesRenderer = function (files) {
    return React.createElement(FileNameList, { files: files });
};
var FileField = /** @class */ (function (_super) {
    __extends(FileField, _super);
    function FileField(props) {
        var _this = _super.call(this, props) || this;
        _this._onInputChange = function (e) {
            var files = [];
            var fileList = _this._ref.files;
            var fl = fileList.length;
            for (var i = 0; i < fl; i++) {
                files.push(fileList.item(i));
            }
            if (_this.props.onChange) {
                _this.props.onChange(files);
            }
            _this.setState({ files: files });
        };
        _this._onFileInputRef = function (ref) {
            _this._ref = ref;
        };
        _this._onFieldGroupClick = function () {
            if (_this._ref) {
                _this._ref.click();
            }
        };
        _this._onClickClear = function () {
            _this.setState({ files: null });
            if (_this.props.onClear) {
                _this.props.onClear();
            }
        };
        _this.state = { files: _this.props.files };
        _this._id = Utilities_1.getId("image-field");
        return _this;
    }
    FileField.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({ files: nextProps.files || [] });
    };
    FileField.prototype.render = function () {
        var selectContent;
        var clearAction;
        var files = this.state.files;
        if (this.props.onClear || (files && files.length > 0)) {
            clearAction = React.createElement(Button_1.IconButton, { iconProps: { iconName: "Clear" }, onClick: this._onClickClear, disabled: this.props.disabled });
        }
        if (this.state.files && this.state.files.length > 0) {
            var r = this.props.onRenderFiles || defaultFilesRenderer;
            selectContent = r(this.state.files);
        }
        else {
            selectContent = this.props.onRenderSelect ? this.props.onRenderSelect() : this.props.defaultSelectText || "Select " + (this.props.multiple ? "Files..." : "a File...");
        }
        var styles = FileField_styles_1.getStyles(undefined, this.props.styles);
        var classNames = FileField_classNames_1.getClassNames(styles, this.props.className);
        return (React.createElement("div", { className: classNames.root },
            React.createElement("input", { id: this._id, type: "file", accept: this.props.accept, onChange: this._onInputChange, ref: this._onFileInputRef, value: "", multiple: this.props.multiple, hidden: true, style: { display: "none" }, disabled: this.props.disabled }),
            React.createElement("div", { className: classNames.wrapper },
                this.props.label && React.createElement(Label_1.Label, { htmlFor: this._id }, this.props.label),
                React.createElement("div", { className: classNames.selector },
                    React.createElement("button", { type: "button", className: classNames.selectorAction, onClick: this._onFieldGroupClick, disabled: this.props.disabled }, selectContent),
                    clearAction))));
    };
    return FileField;
}(React.Component));
exports.FileField = FileField;
